module.exports = __webpack_public_path__ + "img/tree-7.f8856121.png";